import { createAction, props } from '@ngrx/store';

export const loadInstrumentList = createAction('[Instrument] Load List');

export const loadInstrumentListSuccess = createAction(
  '[Instrument] Load List Success',
  props<{ data: any[] }>()
);

export const loadInstrumentListFailure = createAction(
  '[Instrument] Load List Failure',
  props<{ error: any }>()
);

export const clearInstrumentList = createAction('[Instrument] Clear List');
